import React from "react";
import { Link } from "react-router-dom";

const PropBox = ({ propuesta }) => {
  if (!propuesta) return null;
  return (
    <div className="card m-2">
      <div className="card-header">
        <small>
          {propuesta.eje && (
            <span className="badge badge-primary tag mr-2">
              {propuesta.eje}
            </span>
          )}
          Id: #{propuesta._id} (
          <Link
            to={`/consola/imprimir/${propuesta._id}`}
            className="small-link ppr-a"
          >
            Vista para Impresión
          </Link>
          )
        </small>
      </div>
      <div className="card-body">
        <h4 className="card-title">PROPUESTA: {propuesta.titulo}</h4>
        <h6 className="card-text card-subtitle">Autor: {propuesta.autor}</h6>
        <h6 className="card-text">Presupuesto: {propuesta.presupuesto}</h6>
        <p className="card-text">{propuesta.subtitulo}</p>

        <div className="text-right">
          <Link
            to={`/consola/propuesta/${propuesta._id}`}
            className="btn ppr-btn-azul font-weight-bold"
          >
            Administrar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PropBox;
